import { render, staticRenderFns } from "./ContactFieldsNewsletter.vue?vue&type=template&id=3c84408a&"
import script from "./ContactFieldsNewsletter.vue?vue&type=script&lang=js&"
export * from "./ContactFieldsNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports